import { render, staticRenderFns } from "./ZuTips.vue?vue&type=template&id=39b85a5b&scoped=true"
import script from "./ZuTips.vue?vue&type=script&lang=js"
export * from "./ZuTips.vue?vue&type=script&lang=js"
import style0 from "./ZuTips.vue?vue&type=style&index=0&id=39b85a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b85a5b",
  null
  
)

export default component.exports